import React, { useCallback, useState } from 'react';
import useInitialRender from '../../hooks/useInitialRender';
import useHistory from '../../Router/useHistory';
import { useOnHash } from '../../SiteContext/useHashListener';
import Loader from '../../styled/Loader';
import Suspense from '../Suspense';

const SofaBuilder = React.lazy(() => import('.'));

const SofaBuilderLauncher = () => {
  const { location } = useHistory();
  const [show, setShow] = useState(location?.hash === '#soffbyggaren');
  const isInitialRender = useInitialRender(true);

  const onHashChange = useCallback((_prev: string, hash: string) => {
    setShow(hash === '#soffbyggaren');
  }, []);

  const clearHash = useOnHash('#soffbyggaren', onHashChange);

  const onClose = useCallback(() => {
    setShow(false);
    clearHash();
  }, [clearHash]);

  if (!show || isInitialRender()) {
    return null;
  } else {
    // This is to support the old way of open the sofa builder at #soffbyggaren
    window.location.href = '/soffbyggaren/bygg';
  }

  return (
    <div>
      <Suspense fallback={<Loader className="size-large tone-ghost" />}>
        <SofaBuilder onClose={onClose} />
      </Suspense>
    </div>
  );
};

export default SofaBuilderLauncher;
